import React, { useEffect, useState } from "react";
import { Row, Col, Comment, Avatar, Skeleton, Empty, Pagination } from "antd";
import { useDispatch, useSelector } from "react-redux";
import Cards from "./FavoriteCards/Cards";
import { getFavorites } from "../../redux/actions";
import "./MyFavorites.css";
import Loader from "../../components/Loading/Loader";
import noFavoritesDp from "../../assets/img/Emptyjobs.png";
import MobilePagination from "../../components/Pagination/MobilePagination";
import TalentCards from "../PostAJob/EmployerProfile/components/TalentCards/TalentCards";


const MyFavorites = () => {
  const [Dimensions, setDimensions] = useState(getWindowDimensions());
  const [totalCount,setTotalCount]= useState(0);
  // Redux Data*************************
  const aggregate = useSelector(
    (state) => state.favoritesReducer.details.aggregate
  );
  const loading = useSelector((state) => state.favoritesReducer.loading);
  const favorites = useSelector(
    (state) => state.favoritesReducer.details.favorites
  );
  //States********************
  const [currentPage, setCurrentPage] = useState(1);
  const [items, setItems] = useState(null);
  // const [Dimensions, setDimensions] = useState(Dimensions.width);

  //Dispatch******************
  const dispatch = useDispatch();
  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }

  useEffect(() => {
    function handleResize() {
      setDimensions(getWindowDimensions());
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  //API call********************
  useEffect(() => {
    dispatch(getFavorites(currentPage, Dimensions.width > 768 ? "24" : "20",'web'))
    // dispatch(getFavorites(currentPage, "24",
    // //  Dimensions.width > 768? 'web':'mobile'
    // 'web',
    //  ));
  }, [currentPage
    ,Dimensions.width
  ]);

  useEffect(() => {
    setItems(aggregate?.count);
  }, [aggregate]);

  // Functions*******************

  return (
    <div className="favorite">
      {loading ? (
        <Loader />
      ) : (
        <div className="--Favorites">
          <div className="My-Favorites">Favorites</div>
          <div className="itemsNo">{items} items</div>
          <div className="favorites-column">
            {!favorites || favorites.length === 0  ?
             <div className="int-list-center-favorites">
         <img
          src={noFavoritesDp}
          alt="EmptyFavoritepic"
          className="nofavoritedataimage"
        ></img> 
        <div className="nofavoritesdatatext">You have no favorite skill listings</div>
      </div> : 
            <Row>
            
                  {favorites?.map((items,index) => {
                  
                  return (
                    (
                      <Col key={index} className="candidate-card-column-mobile">
                        <Cards {...items} />
                      </Col>
                    )
                  );
                })
             
}
            </Row>}
          </div>

          <div>
            {Dimensions.width < 769 ? (
              <MobilePagination
                span={24}
                current={currentPage}
                // defaultPageSize={6}
                defaultPageSize={24}
                defaultCurrent={1}
                // total={items}
                total={items}
                onChange={(page) => setCurrentPage(page)}
                hideOnSinglePage={true}
              />
            ) : (
              <div style={{ marginLeft: "45%", marginBottom: "10%" }}>
                <Pagination
                  hideOnSinglePage={true}
                  current={currentPage}
                  defaultPageSize={24}
                  showSizeChanger={false}
                  defaultCurrent={1}
                  // total={items}
                  total={items}
                  onChange={(page) => setCurrentPage(page)}
                />
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default MyFavorites;
